export default __webpack_public_path__ + "static/media/popup-card.c6b1cdad.png";